module.exports = __webpack_public_path__ + "img/title1.0fc36c39.svg";